import script from "./policyDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./policyDetail.vue?vue&type=script&lang=ts&setup=true"

import "./policyDetail.vue?vue&type=style&index=0&id=d9c41300&lang=scss&scoped=true"

import exportComponent from "E:\\gitProject\\营城\\yingcheng\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9c41300"]])

export default __exports__